import React from 'react';

import dayjs, { extend } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useTranslation } from 'react-i18next';

import { Status } from '@pkg/components/Navigation/SidebarNav/Sections/YatFantasySection/styles';
import {
    DescriptionWrapper,
    GameTableItem,
    NameContentWrapper,
    StyledGameRowLink,
} from '@pkg/components/Sections/Admin/Fantasy/GameList/styles';
import { useBreakpoints, useGameStatusContent, useGetGameState } from '@pkg/hooks';

import { type Competition } from '@app/client/common/structs';

extend(utc);

interface Props {
    gameData: Competition;
}

export const GameRow = ({ gameData }: Props) => {
    const { t } = useTranslation('admin_fantasy');
    const { gameState } = useGetGameState(gameData);

    const { adminStatusCopy } = useGameStatusContent(gameState);
    const { isMobile } = useBreakpoints();
    function formattedDate(date?: string) {
        return dayjs(date).utc().local().format('YY-MM-DD H:mm ');
    }

    return (
        <StyledGameRowLink to={`${gameData.slug}`} title={t('list_action_edit_title')}>
            <GameTableItem>
                <strong title={gameData.name}>{gameData.name}</strong>
                <DescriptionWrapper>{gameData.description}</DescriptionWrapper>
                <NameContentWrapper>
                    <Status $submissionState={gameState}>{adminStatusCopy}</Status>
                    {`${!gameData.published_at ? t('list_item_name_unpublished') : ''}`}
                </NameContentWrapper>
            </GameTableItem>
            {!isMobile && (
                <GameTableItem>
                    <p>
                        opens:
                        <span>{formattedDate(gameData.submission_starts_at)}</span>
                    </p>
                    <p>
                        Join period ends:
                        <span>{formattedDate(gameData.submission_ends_at)}</span>
                    </p>
                    <p>
                        ends:
                        <span>{formattedDate(gameData.ends_at)}</span>
                    </p>
                </GameTableItem>
            )}
            {!isMobile && (
                <GameTableItem>
                    <p>
                        {t('max_value_title_value')}
                        <span>{gameData.max_value}</span>
                    </p>
                    <p>
                        {t('max_value_title_assets')}
                        <span>{gameData.max_assets}</span>
                    </p>
                    <p>
                        {t('max_value_title_submissions')}
                        <span>{gameData.max_player_count}</span>
                    </p>
                </GameTableItem>
            )}
            {!isMobile && (
                <GameTableItem>
                    <p>
                        prizes:
                        <span>{gameData.prizes?.length ?? 'none'}</span>
                    </p>
                    <p>
                        team prizes:
                        <span>{gameData.team_prizes?.length ?? 'none'}</span>
                    </p>
                    <p>
                        winners:
                        <span>{gameData.winners?.length ?? 'none'}</span>
                    </p>
                    <p>
                        team winners
                        <span>{gameData.team_winners?.length ?? 'none'}</span>
                    </p>
                </GameTableItem>
            )}
        </StyledGameRowLink>
    );
};
